import React from 'react';
import cn from 'classnames';

import Link from 'brandComponents/Link';
import Typography from 'brandComponents/Typography';

import {IBreadcrumbProps} from './IBreadcrumb';

import styles from './Breadcrumb.module.scss';

const Breadcrumb = ({classNames, url, label, category, labelVariant = 'span'}: IBreadcrumbProps) => {
	const categoryName = category?.getName();

	return (
		url ?
			<Link className={cn(styles['breadcrumb__link'], classNames)} to={url}>
				<Typography variant={labelVariant}>{label || categoryName}</Typography>
			</Link>
			:
			<Typography variant={labelVariant}>{label || categoryName}</Typography>
	);
};

export default Breadcrumb;
